export const responseSizeAcceptable = (
    response: unknown,
    details: Record<string, unknown>
): boolean => {
    try {
        const responseSizeBytes = new TextEncoder().encode(JSON.stringify(response)).length
        const responseSizeKB = responseSizeBytes / 1024 // Size in KB
        const responseSizeMB = responseSizeKB / 1024 // Size in MB
        const acceptableLimitMB = 5 // Acceptable size in MB
        const responseTooLarge = responseSizeMB > acceptableLimitMB

        let sizeMessage = ''
        if (responseSizeBytes < 1024) {
            sizeMessage = `${responseSizeBytes} Bytes`
        } else if (responseSizeKB < 1024) {
            sizeMessage = `${responseSizeKB.toFixed(2)} KB`
        } else {
            sizeMessage = `${responseSizeMB.toFixed(2)} MB`
        }

        const logMessage = {
            message: `Response Size: ${sizeMessage}`,
            error: responseTooLarge ? `ERROR: exceeds limit of ${acceptableLimitMB} MB` : undefined,
            details: details
        }

        if (responseTooLarge) {
            console.log('Too Large', logMessage)
            throw new Error(JSON.stringify(logMessage))
        }

        return true
    } catch (error) {
        console.error('Response Size Error:', error)
        console.trace('Stack trace for the error location:')
        return false
    }
}
